import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{ background: '#080808', borderTop: '1px solid rgba(201,168,76,0.15)', marginTop: '80px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '16px' }}>
              <span className="brand-font" style={{ color: '#C9A84C', fontSize: '24px' }}>One</span>
              <span className="brand-font" style={{ color: '#F0EDE8', fontSize: '24px' }}> Stop Shop</span>
            </div>
            <p style={{ color: '#8A8480', fontSize: '13px', lineHeight: 1.7 }}>Your trusted marketplace for land, property and vehicles in Kenya.</p>
          </div>
          <div>
            <h4 style={{ color: '#F0EDE8', fontWeight: 600, marginBottom: '16px', fontSize: '13px', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Services</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { label: 'Land for Sale', to: '/land' },
                { label: 'Houses for Sale', to: '/houses-for-sale' },
                { label: 'Houses for Rent', to: '/houses-for-rent' },
                { label: 'Cars', to: '/cars' },
              ].map(link => (
                <Link key={link.to} to={link.to} style={{ color: '#8A8480', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#C9A84C'}
                  onMouseLeave={e => e.currentTarget.style.color = '#8A8480'}
                >{link.label}</Link>
              ))}
            </div>
          </div>
          <div>
            <h4 style={{ color: '#F0EDE8', fontWeight: 600, marginBottom: '16px', fontSize: '13px', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Coming Soon</h4>
            <p style={{ color: '#444', fontSize: '13px' }}>Courier Services</p>
          </div>
          <div>
            <h4 style={{ color: '#F0EDE8', fontWeight: 600, marginBottom: '16px', fontSize: '13px', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Contact</h4>
            <p style={{ color: '#8A8480', fontSize: '13px', marginBottom: '6px' }}>Kenya</p>
            <a href="mailto:onestopshop254kenya@gmail.com" style={{ color: '#C9A84C', fontSize: '13px', textDecoration: 'none' }}>
              onestopshop254kenya@gmail.com
            </a>
          </div>
        </div>
        <div style={{ borderTop: '1px solid rgba(201,168,76,0.1)', marginTop: '48px', paddingTop: '24px', textAlign: 'center' }}>
          <p style={{ color: '#444', fontSize: '12px' }}>© 2026 One Stop Shop Kenya. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;